<template>
    <app-card class="mb-4">
        <div class="row">
            <div class="col mb-3">
                <input class="form-control custom-green-input-bg" :placeholder="`${$t('Search')}...`" type="text" v-model="term"/>
            </div>
            <div class="col-md-1">
                <app-button v-if="term" native-type="button" type="warning" @click="cancelFilter" class="mt-1" small>
                    {{ $t('Cancel') }}
                </app-button>
                <app-loader-gif class="mt-2" v-if="loading"/>
            </div>
            <div class="col-3 pt-2">
                <!--                <app-radio-->
                <!--                    id="booking_type_present"-->
                <!--                    v-model="booking_type"-->
                <!--                    name="booking_type_present"-->
                <!--                    :label="$t('Currently active')"-->
                <!--                    val="present"-->
                <!--                    @input="toggleBookingType"-->
                <!--                    inline />-->
                <!--                <app-radio-->
                <!--                    id="booking_type_future"-->
                <!--                    v-model="booking_type"-->
                <!--                    name="booking_type_future"-->
                <!--                    :label="$t('Future bookings')"-->
                <!--                    val="future"-->
                <!--                    @input="toggleBookingType"-->
                <!--                    inline />-->
            </div>
            <div class="col-3">
                <app-datepicker id="past_search_dates"
                                v-model="past_search_dates"
                                range
                                :placeholder="$t('Past bookings')"
                                name="past_search_dates"
                                @input="pastBookings"/>
            </div>
        </div>
        <table v-if="bookings.length && !loading" class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th @click="orderBy('confirmed_at')" class="pointer">
                        {{ $t('Confirmed') }}
                        <span v-html="order_field === 'confirmed_at' ? active_sort_icon : sort_icon"/>
                    </th>
                    <th @click="orderBy('start_time')" class="pointer">
                        {{ $t('Pickup') }}
                        <span v-html="order_field === 'start_time' ? active_sort_icon : sort_icon"/>
                    </th>
                    <th @click="orderBy('end_time')" class="pointer">
                        {{ $t('Return') }}
                        <span v-html="order_field === 'end_time' ? active_sort_icon : sort_icon"/>
                    </th>
                    <th @click="orderBy('prices.total')" class="pointer">
                        {{ $t('Price') }}
                        <span v-html="order_field === 'price' ? active_sort_icon : sort_icon"/>
                    </th>
                    <th>{{ $t('Vehicle') }}</th>
                    <th>{{ $t('Client') }}</th>
                    <th>{{ $t('Additional eq') }}</th>
                    <th>{{ $t('Services') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(booking, i) in orderedBookings" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>
                        <template v-if="booking.confirmed_at">
                            {{ booking.confirmed_at | formatDateTime }}
                        </template>
                        <template v-else>
                            {{ $t('Unconfirmed') }}
                        </template>
                        <template v-if="booking.travel_out">
                            <br>
                            <span class="mdi mdi-18px mdi-alert-outline text-danger"/> {{ $t('Travel out of Estonia') }}: <b>{{ booking.travel_out }}</b>
                        </template>
                    </td>
                    <td>
                        {{ booking.start_time | formatDateTime }}
                        <template v-if="booking.pickup_location_id === otherLocationId">
                            <br>
                            <span class="mdi mdi-18px mdi-alert-outline text-danger"/> {{ booking.pickup_location_custom }}
                        </template>
                        <template v-else>
                            <br>
                            {{ booking.pickup_location.name[locale] }}
                        </template>
                    </td>
                    <td>
                        {{ booking.end_time | formatDateTime }}
                        <template v-if="booking.return_location_id === otherLocationId">
                            <br>
                            <span class="mdi mdi-18px mdi-alert-outline text-danger"/> {{ booking.return_location_custom }}
                        </template>
                        <template v-else>
                            <br>
                            {{ booking.return_location.name[locale] }}
                        </template>
                    </td>
                    <td>{{ booking.prices.days }} x {{ booking.prices.day_price / 100 }}€ + {{ booking.prices.bond / 100 }}€</td>
                    <td>
                        {{ booking.vehicle.make.name }} {{ booking.vehicle.model.name }},
                        {{ booking.vehicle.reg_no }}
                    </td>
                    <td>
                        {{ booking.fname }} {{ booking.lname }} <br>
                        <template v-if="booking.phone">
                            {{ booking.phone }} <br>
                        </template>
                        <template v-if="booking.email">
                            {{ booking.email }} <br>
                        </template>
                        {{ $t('Language') }}: {{ $t(langs.find(l => l.key === booking.lang).name) }}
                        <template v-if="booking.promo">
                            <br>
                            <small>{{ $t('Promocode') }}</small> <br>
                            "{{ booking.promo.code }}" <small>-{{ booking.promo.discount_percent }}%</small>
                        </template>
                        <template v-else-if="booking.client_id !== null">
                            <br>
                            <small>{{ $t('Client') }}</small> <br>
                            {{ booking.client.name }} <small>-{{ booking.client.discount_percent }}%</small>
                        </template>
                    </td>
                    <td>
                        <template v-if="booking.additional_eq.length">
                            <template v-for="(eq, i) in additionNames(booking.additional_eq)">
                                {{ eq[locale] }} <br :key="i"/>
                            </template>
                        </template>
                    </td>
                    <td>
                        <template v-if="booking.services.length">
                            <template v-for="(service, i) in booking.services">
                                {{ service.name[locale] }}, {{ service.price / 100 }} EUR <br :key="i"/>
                            </template>
                        </template>
                    </td>
                    <td>
                        <div class="d-flex justify-content-end">
                            <router-link v-if="booking.contract && $store.getters.canViewContracts"
                                         :to="{name: 'contracts.show', params: {contract_id: booking.contract.id}}"
                                         class="btn btn-info btn-sm text-white">
                                {{ $t('Contract') }}
                            </router-link>
                            <router-link :to="{name: 'booking.show', params: {booking_id: booking.id}}"
                                         class="btn btn-info btn-sm ml-2 text-white">
                                {{ $t('View') }}
                            </router-link>
                            <router-link :to="{name: 'booking.edit', params: {booking_id: booking.id}}"
                                         class="btn btn-primary btn-sm ml-2 text-white">
                                {{ $t('Edit') }}
                            </router-link>
                            <app-button native-type="button"
                                        type="danger"
                                        class="m-0 ml-2"
                                        @click="destroy(booking.id)"
                                        v-if="!booking.confirmed_at && !booking.contract"
                                        small>
                                {{ $t('Delete') }}
                            </app-button>
                            <!--                            <app-button native-type="button"-->
                            <!--                                        class="m-0 ml-2"-->
                            <!--                                        @click="sendEmails(booking.id)"-->
                            <!--                                        small>-->
                            <!--                                SM-->
                            <!--                            </app-button>-->
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="text-center">
            {{ $t('No booking between this period') }}
        </div>
    </app-card>
</template>

<script>
import {mapGetters} from 'vuex';
import orderBy from 'lodash/orderBy';
import BookingService from '@services/booking.service';
import AdditionService from '@services/addition.service';
import chunk from 'lodash/chunk';

export default {
    data() {
        return {
            loading: true,
            booking_type: 'current',
            past_search_dates: [],
            term: '',
            order_field: 'created_at',
            order_dir: 'desc',
            sort_icon: '<span class="mdi mdi-18px mdi-menu-swap"/>',
            bookings: [],
            additions: [],
        };
    },
    computed: {
        ...mapGetters(['locale', 'langs', 'otherLocationId']),
        filteredBookings() {
            if (this.bookings.length) {
                const term = this.term.toLowerCase();
                return this.bookings.filter(booking => {
                    return (
                        booking.fname.toLowerCase().match(term) ||
                        booking.lname && booking.lname.toLowerCase().match(term) ||
                        booking.phone && booking.phone.match(term) ||
                        booking.email && booking.email.toLowerCase().match(term) ||

                        booking.client && booking.client.name && booking.client.name.toLowerCase().match(term) ||
                        booking.client && booking.client.phone && booking.client.phone.match(term) ||
                        booking.client && booking.client.email && booking.client.email.toLowerCase().match(term) ||
                        booking.client && booking.client.company_email && booking.client.company_email.toLowerCase().match(term) ||

                        booking.vehicle.make.name.toLowerCase().match(term) ||
                        booking.vehicle.model.name.toLowerCase().match(term) ||
                        booking.vehicle.reg_no.toLowerCase().match(term)
                    );
                });
            }
            return false;
        },
        orderedBookings() {
            return orderBy(this.filteredBookings, this.order_field, this.order_dir);
        },
        active_sort_icon() {
            if (this.order_dir === 'desc') {
                return '<span class="mdi mdi-18px mdi-menu-down"/>';
            } else {
                return '<span class="mdi mdi-18px mdi-menu-up"/>';
            }
        }
    },
    methods: {
        orderBy(field) {
            this.order_field = field;
            if (this.order_dir === 'desc') {
                this.order_dir = 'asc';
            } else {
                this.order_dir = 'desc';
            }
        },
        cancelFilter() {
            this.term = '';
        },
        toggleBookingType(type) {
            this.loading = true;
            this.bookings = [];
            this.getBookings(type);
        },
        getBookings(type) {
            if(type === 'current') {
                BookingService.currentBookings().then(res => {
                    this.bookings = res;
                    this.loading = false;
                    this.getAdditions();
                });
                return;
            }
            // BookingService.presentBookings().then(res => {
            //     this.bookings = res;
            //     this.loading = false;
            //     this.getAdditions();
            // });
        },
        pastBookings(dates) {
            if (dates[0] == null || dates[1] == null) {
                this.booking_type = 'current';
                this.getBookings('current');
                return;
            }
            this.booking_type = false;
            this.loading = true;
            this.bookings = [];
            BookingService.pastBookings(dates).then(res => {
                this.bookings = res;
                this.loading = false;
                this.getAdditions();
            });
        },
        getAdditions() {
            if (!this.additions.length) {
                AdditionService.additions().then(res => {
                    this.additions = res;
                    this.add_eq_arr = chunk(res, 3);
                });
            }
        },
        additionNames(additionIds) {
            let addEqs = [];
            additionIds.map(id => {
                addEqs.push(this.additions.some(add => add.id === id) ? this.additions.find(add => add.id === id).name : {});
            });
            return addEqs;
        },
        sendEmails(bookingId) {
            if (!window.confirm(`${this.$t('Send emails')}?`)) {
                return false;
            }
            BookingService.sendEmails(bookingId);
        },
        destroy(bookingId) {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            BookingService.destroy(bookingId).then(res => {
                const index = this.bookings.findIndex(b => b.id === bookingId);
                this.bookings.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    created() {
        this.getBookings('current');
    }
};
</script>
